'use client';

import React from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const navLinks = [
  { href: '/about-us', label: 'About Us' },
  { href: '/resources', label: 'Resources' },
  { href: '/get-in-touch', label: 'Contact' },
];

interface LandingHeaderProps {
  transparent?: boolean;
}

export const LandingHeader = ({ transparent = false }: LandingHeaderProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <header
        className={cn(
          'w-full z-50',
          transparent 
            ? 'absolute top-0 left-0 bg-transparent' 
            : 'bg-white/80 backdrop-blur-md text-foreground border-b border-foreground/10'
        )}
      >
        <div className="container mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between gap-3">
          <Link
            href="/"
            className="font-display text-xl sm:text-2xl tracking-tight hover:opacity-80 transition-opacity text-primary"
          >
            WILLDONE
          </Link>

          <nav className="hidden md:flex gap-8 text-sm font-medium tracking-wide uppercase">
            {navLinks.map((l) => (
              <Link key={l.href} href={l.href} className="text-primary hover:underline decoration-1 underline-offset-4">
                {l.label}
              </Link>
            ))}
            <Link href="/sign-in" className="text-primary hover:underline decoration-1 underline-offset-4">
              Sign In
            </Link>
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
          <Link href="/write-a-will-online" className="hidden sm:inline-flex">
            <button className="uppercase text-xs font-bold tracking-widest border border-cta bg-cta text-cta-foreground px-4 py-2 hover:bg-cta/90 hover:border-cta/90 transition-colors">
              Write Your Will
            </button>
          </Link>

            <button
              type="button"
              className="md:hidden inline-flex items-center justify-center h-10 w-10"
              aria-label="Open menu"
              onClick={() => setOpen(true)}
            >
              <Menu className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-60 bg-background text-foreground safe-top safe-bottom">
          <div className="px-4 sm:px-6 pt-4 flex items-center justify-between border-b border-foreground/10">
            <div className="font-display text-xl tracking-tight">Menu</div>
            <button
              type="button"
              className="inline-flex items-center justify-center h-10 w-10"
              aria-label="Close menu"
              onClick={() => setOpen(false)}
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <div className="px-4 sm:px-6 py-6 space-y-2">
            {navLinks.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block w-full border border-foreground/10 bg-card px-4 py-4 text-base font-medium text-primary"
              >
                {l.label}
              </Link>
            ))}

            <Link
              href="/sign-in"
              onClick={() => setOpen(false)}
              className="block w-full px-4 py-4 text-base font-semibold text-white bg-primary rounded-lg shadow hover:bg-primary/90 transition-colors"
            >
              Sign In
            </Link>

            <Link href="/write-a-will-online" onClick={() => setOpen(false)} className="block pt-4">
              <button className="w-full uppercase text-sm font-bold tracking-widest border-2 border-cta bg-cta text-cta-foreground py-4">
                Write Your Will
              </button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};



